import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom-v5-compat';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { useModal } from '../../../../../hooks/use-modal';
import { purchaseOrderGridProperties } from '../../data/purchase-order-properties';
import { purchaseOrderStatuses } from '../../data/purchase-order-statuses';
import { PurchaseOrderProvider } from '../../purchase-order-context';
import { PurchaseOrderDrawer } from '../../purchase-order-drawer/purchase-order-drawer';
import { PurchaseOrdersBaseRoute } from '../../purchase-orders-routes';
import { messages } from './../messages';

const name = <FormattedMessage {...messages.purchaseOrderNumberColumnHeader} />;

const PurchaseOrderNumberColumn = ({ data, refreshPurchaseOrders }) => {
  const navigate = useNavigate();
  const { open: openPurchaseOrderDrawer, close: closePurchaseOrderDrawer, isOpen: isPurchaseOrderDrawerOpen } = useModal();

  const [purchaseOrderId, setPurchaseOrderId] = useState();

  const onClick = useCallback(() => {
    if (data.status === purchaseOrderStatuses.draft) {
      setPurchaseOrderId(data.purchaseOrderId);
      openPurchaseOrderDrawer();
      return;
    }
    navigate(`${PurchaseOrdersBaseRoute}/${data.purchaseOrderId}`);
  }, [data.status, data.purchaseOrderId, navigate, openPurchaseOrderDrawer]);
  return (
    <>
      <Button onClick={onClick} theme={THEME_CONSTANTS.link}>
        {data.orderNumber}
      </Button>
      {isPurchaseOrderDrawerOpen ? (
        <PurchaseOrderProvider
          onClose={closePurchaseOrderDrawer}
          purchaseOrderId={purchaseOrderId}
          refreshPurchaseOrders={refreshPurchaseOrders}
        >
          <PurchaseOrderDrawer isCreatingNew={false} />
        </PurchaseOrderProvider>
      ) : null}
    </>
  );
};

/**
 * @param {()=>Promise<void>} refreshPurchaseOrders
 * @returns {import('./types').GridColumn}
 */
export const createPurchaseOrderNumberColumn = (refreshPurchaseOrders) => ({
  id: purchaseOrderGridProperties.purchaseOrderNumber,
  name,
  render: (data) => <PurchaseOrderNumberColumn data={data} refreshPurchaseOrders={refreshPurchaseOrders} />,
});
